// extracted by mini-css-extract-plugin
export var acitonButtons = "_bq-0";
export var additionalIcon = "_bq-f";
export var block = "_bq-1";
export var blockContent = "_bq-7";
export var blockDescription = "_bq-8";
export var blockIcon = "_bq-9";
export var blockTitle = "_bq-6";
export var border = "_bq-a";
export var center = "_bq-l";
export var edge = "_bq-b";
export var edgeLabel = "_bq-c";
export var edgePath = "_bq-d";
export var error = "_bq-e";
export var flowchart = "_bq-g";
export var flowchartContent = "_bq-h";
export var highlighted = "_bq-3";
export var hover = "_bq-4";
export var icon = "_bq-i";
export var left = "_bq-m";
export var navButton = "_bq-j";
export var navButtons = "_bq-k";
export var right = "_bq-n";
export var selected = "_bq-2";
export var small = "_bq-5";